import moment from 'moment-timezone';

export function getDateTimezoneUser(date) {
  return `YOUR TIMEZONE: ${moment(date).tz(moment.tz.guess()).format('DD/MM/YYYY, h:mm:ss a')}'`;
}

export function getDateTimezoneChina(date, showTime) {
  if (showTime) {
    return moment(date).tz('Asia/Hong_Kong').format('DD/MM/YYYY, h:mm:ss a');
  }
  return moment(date).tz('Asia/Hong_Kong').format('DD/MM/YYYY');
}



// WEBPACK FOOTER //
// ./src/helpers/user-timezone.js